import styled from 'styled-components';
import { List } from '@prisjakt/ui/list';
import { Column } from '@prisjakt/ui/list/variants';
import { layout, media } from 'src/components/base';

export const ColumnWithGutter = styled(Column)`
  padding-left: ${layout.measurements.spacing050};
  padding-right: ${layout.measurements.spacing050};
`;

export const ListMobileColumnElseRow = styled(List)`
  flex-direction: column;
  ${media.mediumUp`
      flex-direction: row;
    `}
`;
